import {
  Navigate as Navigate,
  RouterProvider as RouterProvider,
  useParams as useParams,
} from 'react-router';
import { createBrowserRouter as createBrowserRouter } from 'react-router-dom';
import {
  useMemo as useMemo,
  memo as memo,
} from 'react';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_LostRoute3by3r5cvpo4mj as get_LostRoute } from './LostRoute.mjs';
import { jsx3d877eni2yh4i as jsx } from '../../../../../../kotlin-react/react/jsx/runtime/jsx.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_RedirectUnauthenticated3k2ls39zybq83 as get_RedirectUnauthenticated } from './RedirectUnauthenticated.mjs';
import { get_$$UserPage$$UserPage$$react__component$$1if85m5de2lfw as get_$$UserPage$$UserPage$$react__component$$ } from '../user/UserPage__lazy__module.mjs';
import { couplingRoute3755chj8owe7n as couplingRoute } from './CouplingRoute.mjs';
import { get_$$PrereleaseUserPage$$PrereleaseUserPage$$react__component$$1d3j7p2dffifi as get_$$PrereleaseUserPage$$PrereleaseUserPage$$react__component$$ } from '../user/PrereleaseUserPage__lazy__module.mjs';
import { get_$$PartyListPage$$PartyListPage$$react__component$$2yttimtto29ai as get_$$PartyListPage$$PartyListPage$$react__component$$ } from '../party/PartyListPage__lazy__module.mjs';
import { get_Logouta46xaulpbvl3 as get_Logout } from '../user/Logout.mjs';
import { get_$$GraphIqlPage$$GraphIQLPage$$react__component$$1iricxl81n89u as get_$$GraphIqlPage$$GraphIQLPage$$react__component$$ } from '../graphql/GraphIqlPage__lazy__module.mjs';
import { get_$$PartyConfigPage$$PartyConfigPage$$react__component$$iqz78bvnujnu as get_$$PartyConfigPage$$PartyConfigPage$$react__component$$ } from '../party/PartyConfigPage__lazy__module.mjs';
import { get_$$PrepareSpinPage$$PrepareSpinPage$$react__component$$2vcabxyvclzxd as get_$$PrepareSpinPage$$PrepareSpinPage$$react__component$$ } from '../pairassignments/spin/PrepareSpinPage__lazy__module.mjs';
import { get_$$PartySecretsPage$$PartySecretsPage$$react__component$$1e02htfrmrf5p as get_$$PartySecretsPage$$PartySecretsPage$$react__component$$ } from '../party/PartySecretsPage__lazy__module.mjs';
import { get_$$HistoryPage$$HistoryPage$$react__component$$3lqkww3xcegyr as get_$$HistoryPage$$HistoryPage$$react__component$$ } from '../pairassignments/list/HistoryPage__lazy__module.mjs';
import { get_$$IntegrationPage$$IntegrationPage$$react__component$$2lq8hmtj3jksl as get_$$IntegrationPage$$IntegrationPage$$react__component$$ } from '../integration/IntegrationPage__lazy__module.mjs';
import { get_$$PinListPage$$PinListPage$$react__component$$3gv26ju6pi6is as get_$$PinListPage$$PinListPage$$react__component$$ } from '../pin/PinListPage__lazy__module.mjs';
import { get_$$PinPage$$PinPage$$react__component$$358x2i6fdoot6 as get_$$PinPage$$PinPage$$react__component$$ } from '../pin/PinPage__lazy__module.mjs';
import { get_$$CurrentPairsPage$$CurrentPairsPage$$react__component$$3nm6i0upx8r52 as get_$$CurrentPairsPage$$CurrentPairsPage$$react__component$$ } from '../pairassignments/CurrentPairsPage__lazy__module.mjs';
import { get_$$NewPairAssignmentsPage$$NewPairAssignmentsPage$$react__component$$fhalch3bam0i as get_$$NewPairAssignmentsPage$$NewPairAssignmentsPage$$react__component$$ } from '../pairassignments/NewPairAssignmentsPage__lazy__module.mjs';
import { get_$$PlayerPage$$PlayerPage$$react__component$$1tzr5eeofsx2a as get_$$PlayerPage$$PlayerPage$$react__component$$ } from '../player/PlayerPage__lazy__module.mjs';
import { get_$$RetiredPlayersPage$$RetiredPlayersPage$$react__component$$37xlmtdd1zu8q as get_$$RetiredPlayersPage$$RetiredPlayersPage$$react__component$$ } from '../player/retired/RetiredPlayersPage__lazy__module.mjs';
import { get_$$StatisticsPage$$StatisticsPage$$react__component$$2foxgvjvqedut as get_$$StatisticsPage$$StatisticsPage$$react__component$$ } from '../stats/StatisticsPage__lazy__module.mjs';
import { get_$$ContributionOverviewPage$$ContributionOverviewPage$$react__component$$2atql5kjreqrf as get_$$ContributionOverviewPage$$ContributionOverviewPage$$react__component$$ } from '../contribution/ContributionOverviewPage__lazy__module.mjs';
import { get_$$ContributionListPage$$ContributionListPage$$react__component$$1ru6jz46xeu8o as get_$$ContributionListPage$$ContributionListPage$$react__component$$ } from '../contribution/ContributionListPage__lazy__module.mjs';
import { get_$$ContributionVisualizationPage$$ContributionVisualizationPage$$react__component$$b0k1ymcpaa4e as get_$$ContributionVisualizationPage$$ContributionVisualizationPage$$react__component$$ } from '../contribution/ContributionVisualizationPage__lazy__module.mjs';
import { get_$$IncubatingPage$$IncubatingPage$$react__component$$3ld1wy2m1s077 as get_$$IncubatingPage$$IncubatingPage$$react__component$$ } from '../incubating/IncubatingPage__lazy__module.mjs';
import { get_$$SlackConnectPage$$SlackConnectPage$$react__component$$2ssqpnn2r47u2 as get_$$SlackConnectPage$$SlackConnectPage$$react__component$$ } from '../slack/SlackConnectPage__lazy__module.mjs';
import { get_$$SlackCallbackPage$$SlackCallbackPage$$react__component$$3dys71hwi4vq4 as get_$$SlackCallbackPage$$SlackCallbackPage$$react__component$$ } from '../slack/SlackCallbackPage__lazy__module.mjs';
import { get_$$DiscordCallbackPage$$DiscordCallbackPage$$react__component$$yttz7j04kvsc as get_$$DiscordCallbackPage$$DiscordCallbackPage$$react__component$$ } from '../discord/DiscordCallbackPage__lazy__module.mjs';
import { listOfNotNull2woi2boe01ub4 as listOfNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { createywkzgrq4l4xy as create } from '../../../../../../kotlin-react/react/create.mjs';
import {
  component1202hq8a9nou0w as component1,
  component22tb2ggnowdi2j as component2,
  component33ssyybivzamim as component3,
} from './CouplingRouterPropsExtentions.mjs';
import { useAuth0Datar84ij8t1ru66 as useAuth0Data } from '../../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/external/auth0/react/Dsl.mjs';
import { get_$$WelcomePage$$WelcomePage$$react__component$$1nzaxw7oc90ja as get_$$WelcomePage$$WelcomePage$$react__component$$ } from '../welcome/WelcomePage__lazy__module.mjs';
import { get_$$AboutPage$$AboutPage$$react__component$$3iupfptjvn0sm as get_$$AboutPage$$AboutPage$$react__component$$ } from '../AboutPage__lazy__module.mjs';
import { get_$$DemoPage$$DemoPage$$react__component$$3optrozxvrgpv as get_$$DemoPage$$DemoPage$$react__component$$ } from '../demo/DemoPage__lazy__module.mjs';
import { get_LoadingPage24k3wu9brtgnx as get_LoadingPage } from '../demo/LoadingPage.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
  addChild1mvba2e12qyhq as addChild_0,
} from '../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import {
  get_animationsDisabledContext3fr5r59ljcoug as get_animationsDisabledContext,
  get_thirdPartyAvatarsDisabledContextbdytsxs1lpoe as get_thirdPartyAvatarsDisabledContext,
} from '../../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/AnimationsDisabledContext.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
import { FC2myqnqrb760jo as FC } from '../../../../../../kotlin-react/react/FC.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_CouplingRouter() {
  _init_properties_CouplingRouter_kt__qgiow6();
  var tmp = KProperty0();
  return CouplingRouter$delegate.l1m(null, getPropertyCallableRef('CouplingRouter', 0, tmp, _get_CouplingRouter_$ref_heb8xg(), null));
}
var CouplingRouter$delegate;
function get_RedirectToCurrentPairs() {
  _init_properties_CouplingRouter_kt__qgiow6();
  return RedirectToCurrentPairs;
}
var RedirectToCurrentPairs;
function routes(isSignedIn, config) {
  _init_properties_CouplingRouter_kt__qgiow6();
  var tmp;
  if (isSignedIn) {
    tmp = authenticatedRoutes(config);
  } else {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [redirectUnauthenticated()];
  }
  var tmp0 = tmp;
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'kotlin.apply' call
  var this_0 = {};
  // Inline function 'react.create' call
  var this_1 = get_LostRoute();
  this_0.element = jsx(this_1);
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$10 = [this_0];
  return tmp0.concat(tmp$ret$10);
}
function redirectUnauthenticated() {
  _init_properties_CouplingRouter_kt__qgiow6();
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'kotlin.apply' call
  var this_0 = {};
  this_0.path = '*';
  // Inline function 'react.create' call
  var this_1 = get_RedirectUnauthenticated();
  this_0.element = jsx(this_1);
  return this_0;
}
function authenticatedRoutes(_this__u8e3s4) {
  _init_properties_CouplingRouter_kt__qgiow6();
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'kotlin.apply' call
  var this_0 = {};
  this_0.path = '/';
  this_0.element = navigateToPartyList();
  var tmp = this_0;
  var tmp_0;
  if (_this__u8e3s4.d7c_1) {
    tmp_0 = couplingRoute(_this__u8e3s4, '/user', 'User', get_$$PrereleaseUserPage$$PrereleaseUserPage$$react__component$$());
  } else {
    tmp_0 = couplingRoute(_this__u8e3s4, '/user', 'User', get_$$UserPage$$UserPage$$react__component$$());
  }
  var tmp_1 = tmp_0;
  var tmp_2 = couplingRoute(_this__u8e3s4, '/parties/', 'Party List', get_$$PartyListPage$$PartyListPage$$react__component$$());
  var tmp_3 = couplingRoute(_this__u8e3s4, '/logout/', 'Logout', get_Logout());
  var tmp_4 = couplingRoute(_this__u8e3s4, '/graphiql/', 'Graph IQL', get_$$GraphIqlPage$$GraphIQLPage$$react__component$$());
  var tmp_5 = couplingRoute(_this__u8e3s4, '/new-party/', 'New Party', get_$$PartyConfigPage$$PartyConfigPage$$react__component$$());
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'kotlin.apply' call
  var this_1 = {};
  this_1.path = '/:partyId';
  // Inline function 'react.create' call
  var this_2 = get_RedirectToCurrentPairs();
  this_1.element = jsx(this_2);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_3 = listOfNotNull([tmp, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, this_1, couplingRoute(_this__u8e3s4, '/:partyId/prepare/', 'Prepare to Spin', get_$$PrepareSpinPage$$PrepareSpinPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/edit/', 'Party Config', get_$$PartyConfigPage$$PartyConfigPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/secrets/', 'Party Secrets', get_$$PartySecretsPage$$PartySecretsPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/history', 'History', get_$$HistoryPage$$HistoryPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/integrations', 'Pin List', get_$$IntegrationPage$$IntegrationPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/pins', 'Pin List', get_$$PinListPage$$PinListPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/pin/new', 'New Pin', get_$$PinPage$$PinPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/pin/:pinId/', 'Pin Config', get_$$PinPage$$PinPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/pairAssignments/current/', 'Current Pairs', get_$$CurrentPairsPage$$CurrentPairsPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/pairAssignments/new', 'New Pairs', get_$$NewPairAssignmentsPage$$NewPairAssignmentsPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/player/new', 'New Player', get_$$PlayerPage$$PlayerPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/player/:playerId/', 'Player Config', get_$$PlayerPage$$PlayerPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/players/retired', 'Retired Player List', get_$$RetiredPlayersPage$$RetiredPlayersPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/statistics', 'Statistics', get_$$StatisticsPage$$StatisticsPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/contributions', 'Contributions', get_$$ContributionOverviewPage$$ContributionOverviewPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/contributions/list', 'Contributions', get_$$ContributionListPage$$ContributionListPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/:partyId/contributions/visualization', 'Contributions', get_$$ContributionVisualizationPage$$ContributionVisualizationPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/incubating', 'Incubating', get_$$IncubatingPage$$IncubatingPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/integration/slack/connect', 'Slack Connect', get_$$SlackConnectPage$$SlackConnectPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/integration/slack/callback', 'Slack Callback', get_$$SlackCallbackPage$$SlackCallbackPage$$react__component$$()), couplingRoute(_this__u8e3s4, '/integration/discord/callback', 'Discord Callback', get_$$DiscordCallbackPage$$DiscordCallbackPage$$react__component$$())]);
  return copyToArray(this_3);
}
function navigateToPartyList() {
  _init_properties_CouplingRouter_kt__qgiow6();
  var tmp = Navigate;
  return create(tmp, navigateToPartyList$lambda);
}
function CouplingRouter$delegate$lambda($this$nfc, _destruct__k2r9zo) {
  _init_properties_CouplingRouter_kt__qgiow6();
  var animationsDisabled = component1(_destruct__k2r9zo);
  var thirdPartyAvatarsDisabled = component2(_destruct__k2r9zo);
  var config = component3(_destruct__k2r9zo);
  var _destruct__k2r9zo_0 = useAuth0Data();
  var isSignedIn = _destruct__k2r9zo_0.xe();
  var isLoading = _destruct__k2r9zo_0.h3r();
  var tmp0 = [isSignedIn, config];
  // Inline function 'react.useMemo' call
  var callback = () => {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0 = [couplingRoute(config, '/welcome/', 'Welcome', get_$$WelcomePage$$WelcomePage$$react__component$$()), couplingRoute(config, '/about', 'About', get_$$AboutPage$$AboutPage$$react__component$$()), couplingRoute(config, '/demo', 'Demo', get_$$DemoPage$$DemoPage$$react__component$$()), couplingRoute(config, '/loading', 'Loading Test', get_LoadingPage())];
    // Inline function 'kotlin.collections.plus' call
    var elements = routes(isSignedIn, config);
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0.concat(elements);
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'kotlin.apply' call
    var this_0 = {};
    this_0.basename = config.g7c_1;
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'kotlin.apply' call
    var this_1 = {};
    // Inline function 'kotlin.js.asDynamic' call
    this_1['v7_startTransition'] = true;
    this_1.v7_relativeSplatPath = true;
    this_0.future = this_1;
    return createBrowserRouter(tmp, this_0);
  };
  var browserRouter = useMemo(callback, tmp0);
  setDefaultKey($this$nfc, '@rdk/73_4');
  var tmp2 = get_animationsDisabledContext();
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$animationsDisabledContext) => {
    setDefaultKey($this$animationsDisabledContext, '@rdk/74_8');
    var tmp2 = get_thirdPartyAvatarsDisabledContext();
    var tmp4 = thirdPartyAvatarsDisabled;
    // Inline function 'react.ChildrenBuilder.invoke' call
    var block = ($this$thirdPartyAvatarsDisabledContext) => {
      var tmp;
      if (!isLoading) {
        setDefaultKey($this$thirdPartyAvatarsDisabledContext, '@rdk/76_16');
        var tmp2 = RouterProvider;
        // Inline function 'react.ChildrenBuilder.invoke' call
        var block = ($this$RouterProvider) => {
          $this$RouterProvider.router = browserRouter;
          return Unit_instance;
        };
        addChild($this$thirdPartyAvatarsDisabledContext, tmp2, block);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
    addChild_0($this$animationsDisabledContext, tmp2, tmp4, block);
    return Unit_instance;
  };
  addChild_0($this$nfc, tmp2, animationsDisabled, block);
  return Unit_instance;
}
function _get_CouplingRouter_$ref_heb8xg() {
  return () => get_CouplingRouter();
}
function RedirectToCurrentPairs$lambda($this$FC) {
  _init_properties_CouplingRouter_kt__qgiow6();
  setDefaultKey($this$FC, '@rdk/139_4');
  var tmp2 = Navigate;
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = RedirectToCurrentPairs$lambda$lambda;
  addChild($this$FC, tmp2, block);
  return Unit_instance;
}
function RedirectToCurrentPairs$lambda$lambda($this$Navigate) {
  _init_properties_CouplingRouter_kt__qgiow6();
  var params = useParams();
  $this$Navigate.to = '/' + params['partyId'] + '/pairAssignments/current/';
  return Unit_instance;
}
function navigateToPartyList$lambda($this$create) {
  _init_properties_CouplingRouter_kt__qgiow6();
  $this$create.to = '/parties/';
  return Unit_instance;
}
var properties_initialized_CouplingRouter_kt_e3at94;
function _init_properties_CouplingRouter_kt__qgiow6() {
  if (!properties_initialized_CouplingRouter_kt_e3at94) {
    properties_initialized_CouplingRouter_kt_e3at94 = true;
    CouplingRouter$delegate = nfc(CouplingRouter$delegate$lambda);
    var tmp0 = memo(FC(RedirectToCurrentPairs$lambda));
    // Inline function 'seskar.react.internal.withDisplayName' call
    var displayName = 'RedirectToCurrentPairs';
    if (process.env.NODE_ENV !== 'production') {
      // Inline function 'kotlin.js.asDynamic' call
      if (!tmp0.displayName) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp0.displayName = displayName;
      }
    }
    RedirectToCurrentPairs = tmp0;
  }
}
//region block: exports
export {
  get_CouplingRouter as get_CouplingRouter1838eiczuwvo5,
  navigateToPartyList as navigateToPartyList3b7wqux0sp1km,
};
//endregion

//# sourceMappingURL=CouplingRouter.mjs.map
